export interface AddFare {
  effectiveFrom: string;
  adultDailyFare: number;
  adultWeeklyFare?: number;
  adultMonthlyFare?: number;
  adultQuarterlyFare?: number;
  adultAnnualFare?: number;
  childDailyFare?: number;
  childWeeklyFare?: number;
  childMonthlyFare?: number;
  childQuarterlyFare?: number;
  childAnnualFare?: number;
  railcardDailyFare?: number;
  operation: FareOperation;
}

export enum FareOperation {
  Add,
  Edit,
}
